// Which affordance the user was offered to start an app sign-in: a QR to scan with a
// second device, or a tap-through deep link on the phone they're already holding. Sent
// to the mint endpoint so the server-side scan/redeem events can be split the same way.
export type MobileLoginSurface = 'desktop' | 'mobile_browser';

export function mobileLoginSurface(isMobile: boolean): MobileLoginSurface {
  return isMobile ? 'mobile_browser' : 'desktop';
}
